import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmployeeService } from '../../services/employee.service';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AmazingTimePickerService } from 'amazing-time-picker';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { TabsetComponent, TabDirective } from 'ngx-bootstrap/tabs';
import { ModalService } from 'ng-bootstrap-modal';
class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Component({
  selector: 'app-book-appointment',
  templateUrl: './book-appointment.component.html',
  styleUrls: ['./book-appointment.component.scss']
})
export class BookAppointmentComponent implements OnInit {

  dtPendingAppointmentOptions: DataTables.Settings = {};
  patientName: any;
  patientId : any;
  patientEmail: any;
  patientMobile : any;
  doctorsList : any;
  doctorMobile : any;
  doctorId: any;
  startDateValue : Date;
  starttime : any = "19:00";
  endtime: any = "19:00";
  patientAppointments = [];
  appointmentPage: string;
  pageTitle = 'Book Appointment';
  sideBarToggle: any;
  isSlide: any;
  
  constructor(public route: ActivatedRoute, private router: Router , private employeeService: EmployeeService,config: NgbDatepickerConfig, private atp: AmazingTimePickerService,private modalService: ModalService) {
    this.startDateValue = new Date();
    this.getDoctorsList();
  }

  ngOnInit() {
    this.patientId= this.route.snapshot.paramMap.get('id');
    this.patientName = this.route.snapshot.paramMap.get('name');
    this.patientEmail = this.route.snapshot.paramMap.get('email');
    this.patientMobile = this.route.snapshot.paramMap.get('mobile');
    this.appointmentPage = this.route.snapshot.paramMap.get('appointmentPage');
    if(this.appointmentPage == '1'){
      this.pageTitle = 'View Appointments';
    }
    this.getPatientAppointments();
  }

  //get list of doctors.
  getDoctorsList(){
    this.employeeService.getDoctors().subscribe((data: any) =>{
      console.log('data ', data);
      this.doctorsList = data.response.doctotList;
      this.doctorId = this.doctorsList[0].id;
      this.doctorMobile = (this.doctorsList.filter(doctor => doctor.id == this.doctorId))[0].mobile;
    })
    console.log('this.doctorsList ', this.doctorsList);
  }

  selectedDoctorOption(id: any){
    console.log('selected doctor ', id);
    this.doctorId = id;
    this.doctorMobile = (this.doctorsList.filter(doctor => doctor.id == id))[0].mobile;
    console.log('filtered ', this.doctorMobile);
  }

  open() {
    const amazingTimePicker = this.atp.open();
    amazingTimePicker.afterClose().subscribe(time => {
      console.log(time);
    });
  }

  reset(){
    this.router.navigate(['/patientList']);
  }

  tConvert (time) {
    // Check correct time format and split into components
    time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
  
    if (time.length > 1) { // If time format correct
      time = time.slice (1);  // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join (''); // return adjusted time or original string
  }

  bookAppointment(){
    let stime = '01/01/2021 '+(this.starttime)+'';
    let etime = '01/01/2021 '+(this.endtime)+'';
    if(Date.parse(stime) > Date.parse(etime)){
      alert('End Time can not be less than start Time');
    }
    else{
      let aptDate = new Date(this.startDateValue);
      let aptMonth = (aptDate.getMonth() + 1)+"";
      let aptDay = (aptDate.getDate()) + "";
      let aptYear = (aptDate.getFullYear())+"";
      if(aptMonth.length == 1){
        aptMonth = "0"+aptMonth;
      }
      if(aptDay.length == 1){
        aptDay = "0"+aptDay;
      }
      let appointmentstartdate = aptMonth + "-"+aptDay + "-"+aptYear;
      console.log('aptDate ', appointmentstartdate);
      let appointmentData = {
        "empid":this.doctorId,
        "appointmentstartdate":appointmentstartdate,
        "patientid":this.patientId,
        "transactionid":"drrrryui",
        "appointmentstarttime":this.tConvert(this.starttime),
        "appointmentendtime":this.tConvert(this.endtime),
        "isfirstavailable":false,
        "couponcode":"sd2021",
        "couponid":"53"
      }
       this.employeeService.bookPatientAppointment(appointmentData).subscribe((data: any)=>{
        if (data['returnCode'] === 0) {
          alert(data['returnMsg']);
          this.startDateValue = new Date();
          this.starttime = "19:00";
          this.endtime = "19:00";
        }
       }, (err) => {
        alert('Something Went Wrong');
      })
    } 
  }


  //method to get all the appointments of a user.
  getPatientAppointments(){
    this.employeeService.getPatientAppointments(this.patientId).subscribe((data:any)=>{
      this.patientAppointments = data.response.patientAppointmentHistory;
      console.log('apointments ', this.patientAppointments);
      for(let index = 0;index<this.patientAppointments.length;index++){
        if(!this.patientAppointments[index].email){
          this.patientAppointments[index].email = this.patientEmail;
        }
        if(!this.patientAppointments[index].mobile){
          this.patientAppointments[index].mobile = this.patientMobile;
        }
        if(this.patientAppointments[index].isFamilyMember == true){
          this.patientAppointments[index].patientName = this.patientAppointments[index].patientName + " (D)";
        }
        this.patientAppointments[index].AppointmentDate = this.patientAppointments[index].AppointmentDate +'  '+ this.patientAppointments[index].appointmentStartTime;
      }
    })
  }

  CancelAppointments(aptdetails) {
    aptdetails.appointmentStatus = "2";
    let confimationMessage = "Are you sure want to cancel  " + aptdetails.patientName + " appointment";
    if (confirm(confimationMessage)) {
        console.log('confirm msg ', confimationMessage);
        this.modalService.open('confirm', aptdetails);
    }

}

}



// WEBPACK FOOTER //
// ./src/app/admin/book-appointment/book-appointment.component.ts